import { Box, Stack, Text, ThemeIcon } from '@mantine/core';
import { type Icon, IconInbox, type IconProps } from '@tabler/icons-react';
import type { ForwardRefExoticComponent, ReactNode, RefAttributes } from 'react';

type TablerIcon = ForwardRefExoticComponent<IconProps & RefAttributes<Icon>>;

interface EmptyStateProps {
  icon?: TablerIcon;
  title: string;
  description?: string;
  action?: ReactNode;
}

export function EmptyState({
  icon: Icon = IconInbox,
  title,
  description,
  action,
}: EmptyStateProps) {
  return (
    <Box py="xl" px="md">
      <Stack align="center" gap="xs">
        <ThemeIcon size={48} radius="xl" variant="light" color="gray">
          <Icon size={24} />
        </ThemeIcon>
        <Text size="sm" fw={500}>
          {title}
        </Text>
        {description && (
          <Text size="sm" c="dimmed" ta="center" maw={320}>
            {description}
          </Text>
        )}
        {action && <Box mt="xs">{action}</Box>}
      </Stack>
    </Box>
  );
}
